import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {TechnicalDeviceElementsGroupApiService} from '@api/technical-device-elements-group.api.service';
import {Router} from '@angular/router';

@Injectable()
export class ElementGroupResolverService extends BaseResolverService {
    constructor(
        service: TechnicalDeviceElementsGroupApiService,
        router: Router,
    ) {
        super(service, router);
    }
}
